
export enum CustomsControlTypeCd {
	CANADA_TO_US = 'CanadaToUs',
	US_TO_CANADA = 'UsToCanada'}

